export default {
  user: state => state.user
}
